import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { AssignSensorsBulkPayload, AssignSensorsBulkResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<AssignSensorsBulkResponse[], Error, AssignSensorsBulkPayload>,
    'mutationKey' | 'mutationFn'
  >
}

export const useAssignSensorsBulk = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<AssignSensorsBulkResponse[], Error, AssignSensorsBulkPayload>(
    [Entities.Sensors, 'assign-bulk'],
    async (payload) => {
      const { data } = await api.v1AdminSensorsAssignToContractorBulkPost(payload)
      return data as AssignSensorsBulkResponse[]
    },
    options,
  )
}
